<div class="bg-white rounded-lg">
  <div #editor class="h-64"></div>
</div>
